var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0044 18.5806C12.5028 18.091 7.60204 12.9466 7.60204 12.9466C7.47502 12.824 7.37399 12.6771 7.30499 12.5147C7.23599 12.3522 7.20042 12.1775 7.20042 12.001C7.20042 11.8245 7.23599 11.6498 7.30499 11.4873C7.37399 11.3248 7.47502 11.1779 7.60204 11.0554C7.60204 11.0554 12.5028 5.90859 13.0044 5.42139C13.506 4.93179 14.4084 4.89819 14.9424 5.42139C15.4776 5.94219 15.5196 6.67059 14.9424 7.31019L10.446 11.9998L14.9424 16.6894C15.5196 17.329 15.4776 18.0586 14.9424 18.5806C14.4084 19.1038 13.506 19.0714 13.0044 18.5806Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.beb6bf005dd76c913cf05ca5bcc971f3.svg";
export { ForwardRef as ReactComponent };